"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
interface GalleryItem {
  id: string;
  src: string;
  alt: string;
}
const images: GalleryItem[] = [{
  id: "img-1",
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0946-scaled.jpg?v=mhy2dhbd6rr",
  alt: "Lavendelfeld in sanftem Morgenlicht"
}, {
  id: "img-2",
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0947-scaled.jpg?v=ymrcuaxkzw",
  alt: "Ruhiger Behandlungsraum mit Naturleinen"
}, {
  id: "img-3",
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0941-scaled.jpg?v=39m9o7kh83q",
  alt: "Hände mit Kerze und Lavendelblüten"
}, {
  id: "img-4",
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0944-scaled.jpg?v=n6ws2a30ce",
  alt: "Wanderweg in Schweizer Hügellandschaft"
}, {
  id: "img-5",
  src: "https://wandelherz.ch/wp-content/uploads/2026/10/IMG_0945-scaled.jpg?v=azpl8mpwq0o",
  alt: "Blumenstrauss in warmem Licht"
}];
export default function BilderReihe() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : 0.08,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  return <section aria-label="Bilderreihe Über Mich" className="bg-background text-foreground py-12 md:py-16 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl relative z-10">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {images.map((item, index) => {
          const isLastOnMobile = index === 4;
          return <motion.div key={item.id} variants={itemVariants} className={`group relative overflow-hidden rounded-xl border border-border/70 bg-card shadow-xs transition-shadow duration-300 hover:shadow-md ${isLastOnMobile ? "col-span-2 w-1/2 mx-auto md:col-span-1 md:w-full md:mx-0" : ""}`}>
                <div className="relative aspect-square w-full overflow-hidden bg-muted">
                  <img src={item.src} alt={item.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
                </div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}